import { useEffect, useRef, useState } from 'react';
import { getSessionStrict, type BdfzSession } from '../lib/identity';
import { confirmNativeSession, PROFILE_EVENT, readNativeProfile, sessionOwner, type NativeProfile } from './nativeProfile';

export function useNativeAccount() {
  const [session, setSession] = useState<BdfzSession | null>(null);
  const [status, setStatus] = useState('正在確認登入狀態…');
  const [confirmed, setConfirmed] = useState(false);
  const [version, setVersion] = useState(0);
  const revision = useRef(0), mounted = useRef(false);
  async function refresh() {
    const ticket = ++revision.current;
    setConfirmed(false); setStatus('正在確認登入狀態…');
    try {
      const next = await confirmNativeSession(getSessionStrict); sessionOwner(next);
      if (!mounted.current || ticket !== revision.current) return;
      setSession(next); setConfirmed(true);
      setStatus(next.authenticated ? '已連接 My 帳號' : '訪客模式 · 本機練習可繼續');
    } catch {
      if (!mounted.current || ticket !== revision.current) return;
      setSession(null); setStatus('目前無法確認帳號，原有資料保留。請重試或到 My 查看。');
      window.dispatchEvent(new CustomEvent('analects-account-changed', { detail: { slug: null } }));
    }
  }
  useEffect(() => {
    mounted.current = true; void refresh();
    const focus = () => { void refresh(); };
    const invalidated = () => { setSession(null); window.dispatchEvent(new CustomEvent('analects-account-changed', { detail: { slug: null } })); void refresh(); };
    const updated = () => setVersion(value => value + 1);
    window.addEventListener('focus', focus); window.addEventListener('bdfz:session-invalidated', invalidated);
    window.addEventListener(PROFILE_EVENT, updated); window.addEventListener('storage', updated);
    return () => {
      mounted.current = false; ++revision.current;
      window.removeEventListener('focus', focus); window.removeEventListener('bdfz:session-invalidated', invalidated);
      window.removeEventListener(PROFILE_EVENT, updated); window.removeEventListener('storage', updated);
    };
  }, []);
  let profile: NativeProfile | null = null, profileError = '';
  if (confirmed && session) {
    try { profile = readNativeProfile(localStorage, session); }
    catch { profileError = '本機個人設定無法讀取；原有資料保留，尚未修改。'; }
  }
  return { session: confirmed ? session : null, profile, profileError, status, refresh, revision, version };
}
export type NativeAccount = ReturnType<typeof useNativeAccount>;
